module.exports = __webpack_public_path__ + "img/boat.ae1b4257.png";